
import React from "react";
import { Link } from "react-router-dom";

const Footer = () => {
  return (
    <footer className="py-2 w-full px-5 bg-background">
      <div className="flex justify-end items-center space-x-4 text-sm text-muted-foreground">
        <Link to="/privacy" className="hover:text-foreground transition-colors">
          Privacy Policy
        </Link>
        <Link to="/terms" className="hover:text-foreground transition-colors">
          Terms of Service
        </Link>
        <span className="hidden md:inline">© {new Date().getFullYear()} Alfie. All rights reserved.</span>
      </div>
    </footer>
  );
};

export default Footer;
